module.exports = __webpack_public_path__ + "img/big_11B01_blue.02701448.png";